package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.PostDomain
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.repository.PostsRepository

class RequestFavoritePostsUseCase(private val postsRepository: PostsRepository) {

    suspend operator fun invoke(
        postType: PostTypeDomain
    ): Either<NetworkFailure, List<PostDomain>> = when(postType) {
        PostTypeDomain.ACCOMMODATION -> postsRepository.requestFavoriteAccommodationPosts()
        else -> throw NotImplementedError()
    }
}